import { createContext } from 'react';
import { IPauseMonitoringContextValue } from './types';

const PauseMonitoringContext = createContext<IPauseMonitoringContextValue | null>(null);

export default PauseMonitoringContext;
